import { api } from "../../services/api";
import { sortParams } from "./stuffedSort";

// The shared `api` instance carries the bearer token and the 401 -> /login
// interceptor, so these calls need no auth handling of their own.

export const fetchStuffedFilters = async () => {
  const response = await api.get("/stuffed-surplus/filters");
  return response.data;
};

// `startat` is a page index, not a row offset. The UI is 1-based.
// class and order intersect server-side, so both are sent as the user
// drills down; nothing needs stripping.
export const fetchStuffedPage = async ({
  classSlug,
  orderSlug,
  page,
  sort,
}) => {
  let url = `/stuffed-surplus?startat=${page - 1}`;
  if (classSlug) {
    url += `&class=${classSlug}`;
  }
  if (orderSlug) {
    url += `&order=${orderSlug}`;
  }
  // Omitted entirely when neither sort control is set, so the server applies
  // its own default rather than the client asserting an order it was not
  // asked for.
  const ordering = sortParams(sort);
  if (ordering) {
    url += `&sorting=${ordering.sorting}&direction=${ordering.direction}`;
  }
  const response = await api.get(url);
  return response.data;
};

export const fetchStuffedById = async (id) => {
  const response = await api.get(`/stuffed-by-id?stuffed_id=${id}`);
  return response.data;
};
